import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from '../../services/client/model/user';
import { AnswersRepositoryService } from '../../services/answers-repository.service';
import { Router } from '@angular/router';
import { RoutesManagerService } from '../../services/routes-manager.service';

@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.css']
})
export class UserDataComponent {

  form: FormGroup;

  constructor(private fb: FormBuilder, private answersRepository: AnswersRepositoryService, private router: Router, private routesManager: RoutesManagerService) {

    this.createForm();
    this.fetchFormData();
  }

  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      company: ['', Validators.required],
      position: ['', Validators.required],
    });
  }

  fetchFormData() {
    if (this.answersRepository.user) {
      this.form.setValue({
        name: this.answersRepository.user.name,
        lastName: this.answersRepository.user.last_name,
        company: this.answersRepository.user.company,
        position: this.answersRepository.user.position
      });
    }
  }

  saveChanges() {
    if (this.form.invalid) {
      Object.values(this.form.controls).forEach(control => {
        control.markAsTouched();
      });
    }
    else {
      const newUser: User = {
        name: this.name,
        last_name: this.lastName,
        company: this.company,
        position: this.position,
      };
      this.answersRepository.addUser(newUser);
      this.routesManager.setLocalRouteValue('encuesta');
      this.router.navigate(['encuesta']);
    }
  }

  get name() {
    return this.form.get('name').value;
  }

  get lastName() {
    return this.form.get('lastName').value;
  }

  get company() {
    return this.form.get('company').value;
  }

  get position() {
    return this.form.get('position').value;
  }

  get invalidName() {
    return this.form.get('name').invalid && (this.form.get('name').touched || this.form.get('name').dirty);
  }

  get invalidLastName() {
    return this.form.get('lastName').invalid && (this.form.get('lastName').touched || this.form.get('lastName').dirty);
  }

  get invalidCompany() {
    return this.form.get('company').invalid && (this.form.get('company').touched || this.form.get('company').dirty);
  }

  get invalidPosition() {
    return this.form.get('position').invalid && (this.form.get('position').touched || this.form.get('position').dirty);
  }

}
